import horizontalDark from '@/assets/brand/troig-horizontal-negativo.svg';
import horizontal from '@/assets/brand/troig-horizontal.svg';
import symbol from '@/assets/brand/troig-simbolo.svg';
import verticalDark from '@/assets/brand/troig-vertical-negativo.svg';
import vertical from '@/assets/brand/troig-vertical.svg';
import { cn } from '@/lib/utils';

const SOURCES = {
  horizontal: { light: horizontal, dark: horizontalDark },
  vertical: { light: vertical, dark: verticalDark },
  // O símbolo é o mesmo nos dois fundos (branding/README.md).
  symbol: { light: symbol, dark: symbol },
} as const;

/**
 * Marca do troig. `vertical` é a da tela de login; `horizontal`, a da barra lateral aberta;
 * `symbol`, a da barra recolhida.
 *
 * Arquivo por tema, e não SVG inline com `currentColor`: a arte é a mesma do kit em
 * `branding/` (fonte única, com as cores da marca), e duplicar a geometria aqui faria as duas
 * divergirem na primeira revisão do logo. O tamanho vem da altura (`className`), em rem.
 */
export function Logo({
  variant = 'horizontal',
  className,
}: {
  variant?: keyof typeof SOURCES;
  className?: string;
}) {
  const source = SOURCES[variant];
  return (
    <>
      <img src={source.light} alt="troig" className={cn('w-auto dark:hidden', className)} />
      <img
        src={source.dark}
        alt=""
        aria-hidden
        className={cn('hidden w-auto dark:block', className)}
      />
    </>
  );
}
